import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  IAdminLoginRequestBody,
  IAdminLoginResponse,
  IAdminLogoutRequestBody,
  IAdminResetPasswordRequestBody,
  IAdminUpdatePasswordRequestBody,
} from "../../models/admin/adminAuth/adminAuth";
import { Api } from "../..";
import { CustomAction } from "../../store/customAction";
import {
  API_GET_ADMIN_LOGOUT,
  API_POST_ADMIN_DETAILS,
  API_POST_ADMIN_FORGOT_PASSWORD,
  API_POST_ADMIN_LOGIN,
  API_POST_ADMIN_RESET_PASSWORD,
  API_POST_ADMIN_UPDATE_PASSWORD,
} from "../../Apis/ApiEndPoints";

export const adminLogin = createAsyncThunk(
  "adminAuth/adminLogin",
  async (requestBody: IAdminLoginRequestBody, { dispatch }) => {
    const response: IAdminLoginResponse = await CustomAction(
      Api.post(API_POST_ADMIN_LOGIN, requestBody),
      dispatch,
      "adminAuth/adminLogin"
    );

    return response;
  }
);

export const getAdminDetails = createAsyncThunk(
  "adminAuth/adminDetails",
  async (id: string, { dispatch }) => {
    const url = `${API_POST_ADMIN_DETAILS}/${id}`;

    const response = await CustomAction(
      Api.get(url),
      dispatch,
      "adminAuth/adminDetails"
    );

    return response;
  }
);

export const adminResetPassword = createAsyncThunk(
  "adminAuth/adminResetPassword",
  async (requestBody: IAdminResetPasswordRequestBody, { dispatch }) => {
    const response = await CustomAction(
      Api.put(API_POST_ADMIN_RESET_PASSWORD, requestBody),
      dispatch,
      "adminAuth/adminResetPassword"
    );

    return response;
  }
);

export const adminForgotPassword = createAsyncThunk(
  "adminAuth/adminForgotPassword",
  async (toEmail: string, { dispatch }) => {
    const url = `${API_POST_ADMIN_FORGOT_PASSWORD}?toEmail=${encodeURIComponent(
      toEmail
    )}`;

    const response = await CustomAction(
      Api.post(url),
      dispatch,
      "adminAuth/adminForgotPassword"
    );

    return response;
  }
);

export const adminUpdatePassword = createAsyncThunk(
  "adminAuth/adminUpdatePassword",
  async (requestBody: IAdminUpdatePasswordRequestBody, { dispatch }) => {
    const response = await CustomAction(
      Api.put(API_POST_ADMIN_UPDATE_PASSWORD, requestBody),
      dispatch,
      "adminAuth/adminUpdatePassword"
    );

    return response;
  }
);

export const adminLogout = createAsyncThunk(
  "adminAuth/adminLogout",
  async (requestBody: IAdminLogoutRequestBody, { dispatch }) => {
    await CustomAction(
      Api.get(API_GET_ADMIN_LOGOUT, { params: requestBody }),
      dispatch,
      "adminAuth/adminLogout"
    );
  }
);
